export default __webpack_public_path__ + "static/media/Image-2.474ada67.png";